export type WorkingDayHours = { dayOfWeek: number; startTime: string; endTime: string };

export function copyWorkingHours(
  workHours: WorkingDayHours[],
  enabledDays: boolean[],
  sourceDay: number,
  scope: "enabled" | "all",
) {
  const source = workHours[sourceDay];
  if (!source) return { workHours, enabledDays };
  const targetIndexes = scope === "all"
    ? workHours.map((_, index) => index)
    : enabledDays.map((enabled, index) => enabled ? index : -1).filter((index) => index >= 0);
  const targets = new Set(targetIndexes);

  return {
    workHours: workHours.map((hours, index) => targets.has(index)
      ? { ...hours, startTime: source.startTime, endTime: source.endTime }
      : hours),
    enabledDays: enabledDays.map((enabled, index) => targets.has(index) ? enabledDays[sourceDay] : enabled),
  };
}
